export default {
    open: {
        chipColor: '#86CBFF',
        label: window.i18n.__('Ouverte'),
    },
    won: {
        chipColor: '#39CF86',
        label: window.i18n.__('Gagnée'),
    },
    late: {
        chipColor: '#8C909C',
        label: window.i18n.__('En retard'),
    },
    lost: {
        chipColor: '#F6C243',
        label: window.i18n.__('Perdue'),
    },
    cancelled: {
        chipColor: '#AF6DD3',
        label: window.i18n.__('Annulée'),
    },
    closed: {
        chipColor: '#111111',
        label: window.i18n.__('Fermée'),
    },
};
